import { gql } from '@apollo/client';

export const UPDATE_SCHOOL_TERM_DATES = gql`
  mutation updateSchollTermDates($id: ID!, $input: SchoolInput!) {
    updateSchool(id: $id, data: $input) {
      data {
        id
      }
    }
  }
`;
